import { Route, Routes } from 'react-router-dom'
import { FC } from 'react'
import ModuleGuard from 'components/shared/ModuleGuard'
import List from './action-plan/List'
import RealEstateNews from './real-estate-news/RealEstateNewsList'
import MarketUpdatesList from './market-updates/MarketUpdatesList'
import SmartListingAlert from './smart-listing-alert'
import LeadEngagementAlert from './lead-engagement-alert'

export const AutomationRoutes: FC = () => {
 return (
  <Routes>
   <Route
    path="action-plan"
    element={
     <ModuleGuard module="ai_hub_action_plan">
      <List />
     </ModuleGuard>
    }
   />
   <Route
    path="market-updates"
    element={
     <ModuleGuard module="ai_hub_market_update">
      <MarketUpdatesList />
     </ModuleGuard>
    }
   />
   <Route
    path="real-estate-news"
    element={
     <ModuleGuard module="ai_hub_real_estate_news">
      <RealEstateNews />
     </ModuleGuard>
    }
   />
   <Route
    path="ai-listing-intelligence"
    element={
     <ModuleGuard module="ai_hub_listing_intelligence">
      <SmartListingAlert />
     </ModuleGuard>
    }
   />
   <Route
    path="ai-lead-engagement-intelligence"
    element={
     <ModuleGuard module="ai_hub_lead_engagement">
      <LeadEngagementAlert />
     </ModuleGuard>
    }
   />
  </Routes>
 )
}
